<template>
  <div>
    <v-expansion-panels v-model="openedPanel">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h6>{{ title }}</h6>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="mx-n7 mt-n6">
          <slot name="content">
            <p>Content</p>
          </slot>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: "VueElearningVExpansionPanel",

  props: {
    title: {
      default: "title",
    },
     panel: {
      default: null,
    },
    
  },
  watch:{
    panel(newVal){
      this.openedPanel = newVal
    }
  },
  mounted(){
    this.openedPanel = this.panel
  },
  data: () => ({
    openedPanel:null
  })
};
</script>

<style lang="scss" scoped></style>
